'use client'

import { ThemeProvider } from '@emotion/react'
// @ts-ignore
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter'
import CssBaseline from '@mui/material/CssBaseline'
import { MaintenanceRedirect } from 'app/_components/MaintenanceRedirect'
import { LoginInfoProvider, ShortcutActionsProvider } from 'app/_hooks'
import { AppOpenModalProvider } from 'app/_hooks/useAppOpenModal'
import { PlayListSortProvider } from 'app/_hooks/usePlayListSort'
import { PlayListVideoSortProvider } from 'app/_hooks/usePlayListVideoSort'
// @ts-ignore
import { PreviousPageProvider } from 'app/_hooks/usePreviousPage'
import { Amplify } from 'aws-amplify'
import { Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'
import { useParams, usePathname } from 'next/navigation'
import NextTopLoader from 'nextjs-toploader'
import { FC, PropsWithChildren, useEffect } from 'react'
import { SWRConfig } from 'swr'
import { awsExports } from '~/aws'
import { AppLanguagePreparation } from '~/features/i18n/components/AppLanguagePreparation'
import ApolloProviderWrapper from '~/libs/apollo'
import { sendLog } from '~/libs/ga'
import { Colors } from '~/libs/mui/color'
import { theme } from '~/libs/mui/theme'
import { PlaylistActionsProvider } from '../_hooks/usePlaylistActions'
import { SnackbarProvider } from '../_hooks/useSnackbar'
import { AppOpenModal } from './AppOpenModal'
import { ExperimentsSwitcher } from './ExperimentsSwitcher'
import { ShareOpenTracker } from './ShareOpenTracker'
import { UtmParameterStorage } from './UtmParameterStorage'

Amplify.configure({ ...awsExports, ssr: true })

export const Base: FC<PropsWithChildren<{ session: Session | null }>> = ({ session, children }) => {
  const pathname = usePathname()
  const params = useParams()

  useEffect(() => {
    sendLog({
      screen: pathname || 'unknown',
      action: 'page_view',
      value: JSON.stringify(params),
    })
  }, [pathname, params])

  return (
    <AppRouterCacheProvider>
      <SnackbarProvider>
        <PlaylistActionsProvider>
          <PlayListSortProvider>
            <PlayListVideoSortProvider>
              <SessionProvider session={session}>
                <AppLanguagePreparation>
                  <ApolloProviderWrapper>
                    <ThemeProvider theme={theme}>
                      <SWRConfig
                        value={{
                          revalidateOnFocus: false,
                        }}
                      >
                        <ShortcutActionsProvider>
                          <CssBaseline />
                          <NextTopLoader color={Colors.yellow} showSpinner={false} />
                          <LoginInfoProvider>
                            <PreviousPageProvider>
                              <ExperimentsSwitcher>
                                <AppOpenModalProvider>
                                  <MaintenanceRedirect>{children}</MaintenanceRedirect>
                                  <AppOpenModal />
                                </AppOpenModalProvider>
                                <ShareOpenTracker />
                                <UtmParameterStorage />
                              </ExperimentsSwitcher>
                            </PreviousPageProvider>
                          </LoginInfoProvider>
                        </ShortcutActionsProvider>
                      </SWRConfig>
                    </ThemeProvider>
                  </ApolloProviderWrapper>
                </AppLanguagePreparation>
              </SessionProvider>
            </PlayListVideoSortProvider>
          </PlayListSortProvider>
        </PlaylistActionsProvider>
      </SnackbarProvider>
    </AppRouterCacheProvider>
  )
}
